import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px 0 20px 50px;
`;
export const Title = styled.h1`
  font-size: 40px;
`;

export const TitleContact = styled.h2`
  display: inline-block;
  margin-top: 25px;
  padding-left: 15px;
  font-size: 36px;
`;

export const Message = styled.h3`
display: flex;
justify-content: center;
width: 90%;
/* background-color: #fff; */
margin-left: auto;
margin-right: auto;
`
